import styled from 'styled-components'

const Wrapper = styled.section`
display: flex;
align-items: flex-start;

background: gainsboro;
`
export default Wrapper
